module.exports = __webpack_public_path__ + "static/img/email_icon.f0454042.png";